import { useEffect, useState } from "react";

export const useMounted = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};

export const useOnMount = (fn: () => void) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted((mounted) => {
      if (mounted) return true;
      fn();
      return true;
    });
  }, [fn]);

  return mounted;
};
